<template>
  <div class="staff-information">
    <div class="app-panel blank-h blank-v">
      <div class="app-control">
        <el-image :src="datas.face_data.attachment_access_url"></el-image>
        <div class="info">
          <p class="text">{{datas.attr_data.user_attr_name}}</p>
          <el-tag size="small" v-if="datas.attr_data.user_attr_gender === 1">男</el-tag>
          <el-tag size="small" type="danger" v-else>女</el-tag>
          <el-tag type="warning" size="small">{{datas.attr_data.user_attr_department || '--'}}</el-tag>
          <el-tag type="success" size="small">{{datas.attr_data.user_attr_title || '--'}}</el-tag>
        </div>
      </div>
    </div>
    <div class="app-panel blank-h blank-v">
      <div class="app-control">
        <p class="title">到访轨迹</p>
      </div>
      <el-table :data="logDatas" v-loading="loading">
        <el-table-column label="日期" prop="recognition_day"></el-table-column>
        <el-table-column label="到访频次" prop="day_count"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="scan(row.recognition_day)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center append-to-body>
      <el-timeline>
        <el-timeline-item hide-timestamp v-for="(m, n) in logInfo" :key="n">
          <p>
            <span>{{m.user_recognition_log_recognition_at.split(' ')[1]}}</span>
            <el-image :src="m.provide_attachment_data.attachment_access_url" :preview-src-list="[m.provide_attachment_data.attachment_access_url]"></el-image>
            <span>{{m.user_recognition_log_location_name}}</span>
          </p>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>
  </div>
</template>

<script>
  import StaffService from '@/io/staff.js';

  export default {
    name: 'StaffInformation',
    props: {
      staffId: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        dialog: {
          title: '到访轨迹详情',
          show: false
        },
        datas: {
          face_data: {
            attachment_data: {}
          },
          attr_data: {}
        },
        loading: false,
        projectId: '',
        logDatas: [],
        logInfo: []
      }
    },
    watch: {
      staffId: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
            this.initLogDatas();
          }
        },
        immediate: true
      }
    },
    methods: {
      initDatas() {
        StaffService.staffInfo(this.staffId).then(res => {
          this.datas = res.data;
        }).catch(() => {});
      },
      initLogDatas() {
        this.loading = true;
        StaffService.log(this.staffId).then(res => {
          this.logDatas = res.data;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      scan(date) {
        this.dialog.show = true;
        StaffService.logList(this.staffId, date).then(res => {
          this.logInfo = res.data;
        }).catch(() => {});
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .staff-information {
    .app-panel {
      & + .app-panel {
        margin-top: @distance;
      }
      .app-control {
        margin: 0 -10px;
        & > * {
          margin: 0 10px;
        }
        .el-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        .info {
          .text {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .el-tag {
            min-width: 45px;
            text-align: center;
          }
        }
        .right-region {
          & > p {
            padding: 20px;
            border-radius: 4px;
            span {
              text-align: center;
              display: block;
              padding: 5px;
              &:nth-of-type(1) {
                font-weight: bold;
                color: @color-primary;
              }
              &:nth-of-type(2) {
                font-weight: bold;
                color: @color-text-3;
              }
            }
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          i {
            margin-right: 5px;
            color: @color-primary;
          }
        }
      }
      .el-table {
        margin-top: @distance;
      }
    }
  }
  .el-drawer__wrapper {
    .el-drawer__container {
      .el-drawer {
        .el-drawer__body {
          .item {
            box-shadow: @box-shadow-1;
            margin: 20px 40px;
            border-radius: 4px;
            position: relative;
            &.open {
              .app-control {
                .right-region {
                  .btn {
                    transform: rotate(90deg);
                  }
                }
              }
            }
            .time {
              position: absolute;
              top: -13px;
              left: -20px;
              background: @color-primary;
              color: @color-white;
              padding: 5px 10px;
              border-radius: 4px;
            }
            .app-control {
              .title {
                padding: 20px;
                font-weight: bold;
              }
              .right-region {
                .btn {
                  width: 30px;
                  height: 30px;
                  color: @color-primary;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;
                  margin-right: 20px;
                  transition: all @time;
                  cursor: pointer;
                  &:hover {
                    background-color: @color-primary;
                    color: @color-white;
                  }
                }
              }
            }
            .el-timeline {
              padding: 0 40px;
            }
          }
        }
      }
    }
  }
  /deep/ .el-timeline {
    padding: 35px 20px 0 20px;
    .el-timeline-item {
      .el-timeline-item__wrapper {
        top: -35px;
        .el-timeline-item__content {
          p {
            display: flex;
            background-color: @color-4;
            padding: 15px 20px;
            border-radius: 6px;
            .el-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
</style>